import * as Sentry from "@sentry/react";

const SentryInit = () => {
  // Sentry will work only for production mode
  if (process.env.REACT_APP_MODE !== "prod") return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      Sentry.browserProfilingIntegration()
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,

    beforeSend(event) {
      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];

      const isFromGoogleAnalytics = frames.some((frame) =>
        frame?.filename?.includes("google-analytics.com/analytics.js")
      );

      if (isFromGoogleAnalytics) return null;

      return event;
    }
  });
};

SentryInit();
